<template>
  <div class="sb-navigation">
    <div class="position-relative py-3">
      <div
        v-for="(nav, nav_idx) in tcfd_contents"
        :key="`navigation-group-${nav_idx}-${nav.category_code}`"
        class="navigation-group"
      >
        <div :class="['d-block align-items-center', { 'mt-4': nav_idx !== 0 }]">
          <h5
            class="nav-title nav-title--parent"
            :data-observe-anchor="'rp' + nav.category_code"
            :class="{
              'navigation-indicator': nav_idx === 0
            }"
          >
            <b-link
              class="nav-anchor text-keep-all text-decoration-none"
              @click="scroll_to_title('rp' + nav.category_code)"
            >
              <span v-show="lang === 'KOR'">{{ nav.category_name }}</span>
              <span v-show="lang === 'ENG'">{{ nav.category_name_e }}</span>
            </b-link>
          </h5>
        </div>

        <h6
          v-for="(subtopic, subtopic_idx) in nav.indicators"
          :key="'g' + subtopic_idx"
          :class="['nav-title nav-title--child', 'mb-0', 'ml-3']"
          :data-observe-anchor="'w' + subtopic.tcfd_code"
        >
          <b-link
            class="nav-anchor text-keep-all text-decoration-none"
            @click="scroll_to_title('w' + subtopic.tcfd_code)"
          >
            <span v-show="lang === 'KOR'">
              {{ subtopic.tcfd_code }}
            </span>
            <span v-show="lang === 'ENG'">{{ subtopic.tcfd_code }}</span>
          </b-link>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'TCFDTocViewer',
  computed: {
    ...mapGetters('story_board', ['selected_lv2']),
    ...mapState('report_contents', ['tcfd_contents']),
    ...mapState('report_list', ['lang']),
    ...mapGetters('report_list', ['selected_report']),
    anchorList() {
      return this.tcfd_contents.reduce((_anchors, navEle) => {
        if (navEle?.category_code) {
          _anchors.push(`#rp${navEle.category_code}`);
        }
        if (navEle?.indicators && navEle.indicators.length) {
          navEle.indicators.forEach(subtopic => {
            _anchors.push(`#w${subtopic.tcfd_code}`);
          });
        }
        return _anchors;
      }, []);
    }
  },
  mounted() {
    setTimeout(() => {
      this.anchorObserver = new IntersectionObserver(this.handlerObserveAnchor, {
        rootMargin: '0% 0% -78.5% 0%',
        threshold: 1
      });
      this.anchorList.forEach(_anchor => {
        const _anchorTitle = document.querySelector(_anchor);
        if (_anchorTitle) {
          this.anchorObserver.observe(_anchorTitle);
        }
      });
      const initialNav = document.querySelector('.navigation-indicator');
      const color = this.selected_report?.main_color;
      if (initialNav && color) {
        initialNav.style.borderRight = `4px solid ${color}`;
      }
    }, this.observeDealyTimeSleep);
  },
  data() {
    return {
      nchorObserver: null
    };
  },
  methods: {
    handlerObserveAnchor(entries, observer) {
      if (entries.length) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const _navToAnchor = document.querySelectorAll(
              `[data-observe-anchor="${entry.target.id.replace(/#/g, '')}"]`
            );
            if (_navToAnchor.length) {
              const boundingRect = _navToAnchor[0].getBoundingClientRect();
              const offsetTop =
                boundingRect.top -
                document.querySelector('.sb-navigation').getBoundingClientRect().top;
              const _activedNavs = document.querySelectorAll('.navigation-indicator');
              if (_activedNavs.length) {
                _activedNavs.forEach(_activedNav => {
                  _activedNav.classList.remove('navigation-indicator');
                  _activedNav.style.borderRight = '';
                });
              }
              this.activatedAnchor = entry.target.id.replace(/#/g, '');
              const color = this.selected_report?.main_color;
              if (color) {
                const node = _navToAnchor[0].childNodes[0];
                node.classList.add('navigation-indicator');
                node.style.borderRight = `4px solid ${color}`;
              }
            }
          }
        });
      }
    },
    scroll_to_title(link) {
      const element = document.getElementById(link);
      if (element) {
        element.style.scrollMarginTop = '100px';
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<style></style>
